module.exports = __webpack_public_path__ + "img/9581f004bb05cb3b941a6ac6f5a673cc.png";